import { combineReducers } from 'redux';
import usersWP from './usersWP';
import postsWP from './posts/postsWP';
import postWP from './posts/postWP';
import categoriesWP from './posts/categoriesWP';
import tagsWP from './posts/tagsWP';
import pagesWP from './pagesWP';
import storesWP from './stores/storesWP';
import categoriesStoreWP from './stores/categoriesStoreWP';
import tagsStoreWP from './stores/tagsStoreWP';
import productsWP from './products/productsWP';
import categoriesProductWP from './products/categoriesProductWP';
import tagsProductWP from './products/tagsProductWP';
import productsOneWP from './products/productsOneWP';
import menusWP from './menusWP';
import storeOneWP from './stores/storeOneWP';
import headerMenus from './headerMenusWP';
import termOneWP from './termOneWP';
import career from './career';

const rootReducers = combineReducers({
    usersWP,
    postsWP,
    postWP,
    categoriesWP,
    tagsWP,
    pagesWP,
    storesWP,
    categoriesStoreWP,
    tagsStoreWP,
    productsWP,
    categoriesProductWP,
    tagsProductWP,
    productsOneWP,
    menusWP,
    storeOneWP,
    headerMenus,
    termOneWP,
    career
});

export default rootReducers;



// WEBPACK FOOTER //
// ./src/reducers/index.tsx